import React, {useEffect, useState} from 'react';
import ReactMapGL from 'react-map-gl';
import Social from './extras/Social';

const Mapa = () => {
	const [datosusuario, setDatosUsuario] = useState({});
	const [viewport, setViewport] = useState({});

	useEffect(() => {
		const obtenerDatos = async () => {
			const url = 'https://ipapi.co/json/';
			const datos = await fetch(url).then((resp) => resp.json());
			setDatosUsuario({
				city: datos.city,
				country: datos.country,
				lat: datos.latitude,
				lon: datos.longitude,
			});
		};
		obtenerDatos();
	}, []);

	useEffect(() => {
		if (Object.keys(datosusuario).length === 0) return;

		setViewport({
			latitude: datosusuario.lat,
			longitude: datosusuario.lon,
			width: 'auto',
			height: '70vh',
			zoom: 12,
			scrollZoom: false,
		});
	}, [datosusuario]);

	return (
		<section className='mapa'>
			<ReactMapGL
				{...viewport}
				mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
				onViewportChange={(viewport) => {
					setViewport(viewport);
				}}
				mapStyle='mapbox://styles/eduardogpc1/ckswikeuq403b17mjeol89bmc'>
				<div className='mapa__pin'>
					<div className='mapa__pin-box'>
						{datosusuario.country === 'CO' ? (
							<>
								<h3>Hacemos envíos hasta {datosusuario.city}</h3>
								<Social color='black' />
							</>
						) : (
							<>
								<h3>Desafortunadamente no hacemos envíos hasta {datosusuario.city}</h3>
							</>
						)}
					</div>
				</div>
			</ReactMapGL>
		</section>
	);
};

export default Mapa;
